import { useState } from 'react';
import { useI18n } from '../lib/i18n';
import { sameAccount, foreignFields, isActiveAccount, accountStatusLabel, accountTypeLabel } from '../lib/banks';

// ============================================================
// Računi sopstvene firme iz registra (pravljenje naloga i Podaci agencije):
// računi se biraju sami; spisak se otvara samo ako korisnik želi drugi račun.
// ============================================================
export default function OwnAccounts({ accounts, accountDom, accountIno, onPickDom, onPickFx }) {
  const { tr } = useI18n();
  const [open, setOpen] = useState(false);
  if (!accounts?.length) return null;

  if (!open) {
    return (
      <button type="button" onClick={() => setOpen(true)} style={s.link}>
        {tr('Izaberi drugi račun', 'Choose another account', 'Выбрать другой счёт')} ({accounts.length})
      </button>
    );
  }

  return (
    <div style={s.box}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div style={s.title}>{tr('Vaši računi', 'Your accounts', 'Ваши счета')}</div>
        <button type="button" onClick={() => setOpen(false)} style={s.link}>{tr('Zatvori', 'Close', 'Закрыть')}</button>
      </div>
      <div style={s.hint}>
        {tr('Izaberite dinarski račun i račun za uplate iz inostranstva. Mnoge banke devize primaju na isti račun.',
          'Choose the RSD account and the account for payments from abroad. Many banks receive foreign currency on the same account.',
          'Выберите счёт в динарах и счёт для оплат из-за рубежа.')}
      </div>
      {/* Aktivni računi prvi; ugašeni i blokirani su označeni */}
      {[...accounts].sort((x, y) => isActiveAccount(y) - isActiveAccount(x)).map((a) => {
        const dom = sameAccount(a.account, accountDom);
        const fx = sameAccount(a.account, accountIno);
        const active = isActiveAccount(a);
        const kind = accountTypeLabel(a);
        return (
          <div key={a.account} style={{ ...s.row, ...(active ? {} : s.inactive) }}>
            <div style={{ minWidth: 0 }}>
              <div className="mono" style={s.acc}>{a.account}</div>
              <div style={s.bank}>
                {a.bank || foreignFields(a).iban_bank}
                {kind && ` · ${kind}`}
                {!active && <span style={s.warn}> · {accountStatusLabel(a) || 'nije aktivan'}</span>}
              </div>
            </div>
            <div style={s.btns}>
              <button type="button" onClick={() => onPickDom(a)} style={{ ...s.pick, ...(dom ? s.on : {}) }}>
                {dom ? '✓ ' : ''}{tr('Dinarski', 'RSD', 'Динары')}
              </button>
              <button type="button" onClick={() => onPickFx(a, foreignFields(a))} style={{ ...s.pick, ...(fx ? s.on : {}) }}>
                {fx ? '✓ ' : ''}{tr('Inostranstvo', 'Abroad', 'Из-за рубежа')}
              </button>
            </div>
          </div>
        );
      })}
    </div>
  );
}

const s = {
  box: { background: 'var(--paper)', border: '1px solid var(--line)', borderRadius: 10, padding: '10px 12px', margin: '0 0 14px', display: 'flex', flexDirection: 'column', gap: 8 },
  title: { fontSize: 13, fontWeight: 700, color: 'var(--ink-900)' },
  hint: { fontSize: 12, color: 'var(--ink-500)', lineHeight: 1.4 },
  row: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10, flexWrap: 'wrap', background: 'var(--surface)', border: '1px solid var(--line)', borderRadius: 8, padding: '8px 10px' },
  acc: { fontSize: 13, fontWeight: 600, color: 'var(--ink-900)' },
  bank: { fontSize: 12, color: 'var(--ink-500)' },
  link: { alignSelf: 'flex-start', border: 'none', background: 'none', padding: 0, margin: '-4px 0 14px', color: 'var(--teal-800)', fontWeight: 600, fontSize: 13, textDecoration: 'underline', cursor: 'pointer' },
  inactive: { opacity: 0.65 },
  warn: { color: 'var(--red-600)', fontWeight: 600 },
  btns: { display: 'flex', gap: 6 },
  pick: { border: '1px solid var(--line)', background: 'var(--surface)', color: 'var(--ink-700)', borderRadius: 8, padding: '5px 10px', fontSize: 12, fontWeight: 600, cursor: 'pointer' },
  on: { borderColor: 'var(--lavender-700)', background: 'var(--lavender-100)', color: 'var(--teal-800)' },
};
